import {
    all, put, takeLatest,
} from 'redux-saga/effects';

import {
    SET_WIDGET_COOKIES,
    hideBanner,
    reloadPage,
    setCookieTimer,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    // Reload the page to load the scripts only if necessary, ie if the user has accepted
    // the marketing category, since analytics scripts are launched by default at the start
    // The conditional statement is made on one of the marketing cookies, since they are either
    // all accepted, either all refused
    if (document.cookie.indexOf('FACEBOOK_PIXEL') > -1) {
        yield put(reloadPage());
    }
    yield all([
        put(setCookieTimer()),
        put(hideBanner()),
    ]);
}

export function* watch() {
    yield takeLatest(SET_WIDGET_COOKIES, callAction);
}
